import { useEffect, useState, useCallback } from "react";
import { api } from "../lib/api";

/**
 * Loads the analytics summary and refreshes it on a fixed cadence.
 *
 * Behavior is intentionally identical to the previous inline implementation
 * inside the Dashboard page: one initial load, then polling every 5 seconds,
 * with errors logged (not thrown) and a `loading` flag that flips false after
 * the first attempt completes.
 *
 * @returns {{ data: object|null, loading: boolean, reload: () => Promise<void> }}
 */
export function useDashboardData() {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  const load = useCallback(async () => {
    try {
      const res = await api.analytics();
      setData(res.data);
    } catch (e) {
      console.error("Dashboard: failed to load analytics summary", e);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    load();
    const t = setInterval(load, 5000);
    return () => clearInterval(t);
  }, [load]);

  return { data, loading, reload: load };
}
